import "../styles/FrequentlyAskedQuestions.css";

const FrequentlyAskedQuestions = () => {
  return (
    <>
      <div className="faq__container">
        <h1>Frequently Asked Questions - Bribie Island Picnics</h1>

        <section className="faq__content--container">
          <div className="faq__content--item">
            <h2>1. What services do you offer?</h2>
            <p>
              We specialise in luxury picnic and special event styling,
              including couples and group picnics, micro weddings, celebrations
              of life, staff parties, special events, workshops, and more.
              Styling is available at your chosen venue and location.
            </p>
          </div>

          <div className="faq__content--item">
            <h2>2. What times of day can I book a picnic or event setup?</h2>
            <p>
              We offer a range of time options to suit your event style:
              Sunrise, Morning, Lunch, Afternoon, and Sunset sessions are
              available. Timing is subject to availability and season—sunset
              sessions are especially popular and book quickly.
            </p>
            <p>
              Our latest packup time for Sunset Picnic is seasonal (before
              dark).
            </p>
          </div>

          <div className="faq__content--item">
            <h2>3. How do I book?</h2>
            <p>
              Send us an enquiry through our booking form with your preferred
              date, time, event type, and location. We'll check availability and
              provide a quote.
            </p>
          </div>

          <div className="faq__content--item">
            <h2>4. Do you require a deposit?</h2>
            <p>
              Yes. A non-refundable deposit is required to secure your booking.
              A final full payment is due 72 hours prior to your event.
            </p>
          </div>

          <div className="faq__content--item">
            <h2>5. How much does it cost?</h2>
            <p>
              Picnic hire settings start from $195, and all special events are
              quoted based on your vision, number of guests, and location.
            </p>
          </div>

          <div className="faq__content--item">
            <h2>
              6. Can we bring our own food and drink or do you provide food and
              drinks?
            </h2>
            <p>Yes, you can bring your own food and drinks. </p>
            <p>
              For a smaller picnic booking we can arrange beverages, a
              charcuterie plater or food from your favourite local eatery. There
              may be an additional $20 fee for pick up and delivery from your
              favourite local eatery.
            </p>
          </div>

          <div className="faq__content--item">
            <h2>7. Can you set up at my home or private venue?</h2>
            <p>
              Yes! We offer mobile styling and can set up at venues, offices, or
              approved public spaces (permits may be required). We do not setup
              in private homes.
            </p>
          </div>

          <div className="faq__content--item">
            <h2>8. What if it rains?</h2>
            <p>
              Before the picnic is setup, in the event of extreme or unpredicted
              weather where we cannot set up your picnic, we will offer to
              reschedule or provide a refund for everything except from
              prearranged catering.
            </p>
            <p>
              Once the picnic is setup, if your picnic is interrupted by
              unforeseen weather, your picnic is non refundable.
            </p>
          </div>

          <div className="faq__content--item">
            <h2>9. How long is the hire period?</h2>
            <p>
              Standard hire is upto 3 hours, depending on your package. Extra
              time can be arranged with prior notice and may incur additional
              fees.
            </p>
          </div>

          <div className="faq__content--item">
            <h2>10. What areas do you service?</h2>
            <p>We service Bribie Island and Sandstone Point.</p>
          </div>

          <div className="faq__content--item">
            <h2>11. What happens if something gets damaged?</h2>
            <p>
              You're responsible for any lost, damaged, or excessively soiled
              items. A security bond may be required. Costs for replacement or
              repairs will be charged accordingly.
            </p>
          </div>
          <div className="faq__content--item">
            <h2>12. Can you capture our special occasion?</h2>
            <p>
              We're more than happy to take a few photos for you on your phone
              or camera upon arrival or before departure.
            </p>
          </div>
          <div className="faq__content--item">
            <h2>13. What if some guests don't show up on the day?</h2>
            <p>
              All styling and hire services are prepared and charged based on
              your confirmed guest numbers. Unfortunately, we do not offer
              refunds or credits for guests who are a no-show, as all items are
              already prepared and styled in advance.
            </p>
          </div>
        </section>
      </div>
    </>
  );
};
export default FrequentlyAskedQuestions;
